"use strict";
var Accordion = /** @class */ (function () {
    function Accordion(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.allowAllClosed, allowAllClosed = _c === void 0 ? true : _c, _d = _b.deactivateOthers, deactivateOthers = _d === void 0 ? false : _d;
        this.allowAllClosed = allowAllClosed;
        this.deactivateOthers = deactivateOthers;
    }
    // Initialize accordion functionality
    Accordion.prototype.init = function () {
        var _this = this;
        var currentHash = window.location.hash;
        var accordions = document.querySelectorAll(".accordion > .accordion-navigation > a");
        var contents = document.querySelectorAll(".accordion > .accordion-navigation > div.content");
        accordions.forEach(function (accordionAnchor) {
            // Pre-activate accordion based on URL hash
            if (currentHash === accordionAnchor.getAttribute("href")) {
                _this.toggleActive(accordionAnchor);
            }
            // Attach event listeners to each accordion anchor
            accordionAnchor.addEventListener("click", _this.handleToggleEvent.bind(_this), true);
            accordionAnchor.ariaExpanded = "false";
        });
        contents.forEach(function (contentDiv) {
            // Set the aria-hidden for all content elements to true initially
            contentDiv.ariaHidden = "true";
            contentDiv.setAttribute("inert", "");
        });
    };
    // Handle the accordion click event
    Accordion.prototype.handleToggleEvent = function (event) {
        event.preventDefault();
        this.toggleActive(event.currentTarget);
    };
    // Open or close the clicked accordion content
    Accordion.prototype.toggleActive = function (element) {
        var elementParent = element.parentElement;
        var content = elementParent.querySelector(".content");
        var isOpen = elementParent.classList.contains("active");
        // Close other accordions if deactivateOthers is true
        this.deactivateOthers = elementParent.parentElement.classList.contains("autocollapse");
        if (!isOpen) {
            if (this.deactivateOthers) {
                var activeElements = elementParent.parentElement.querySelectorAll(".accordion-navigation .content.active");
                activeElements.forEach(function (activeElement) {
                    activeElement.parentElement.classList.remove('active');
                    activeElement.classList.remove('active');
                    activeElement.ariaHidden = "true";
                    activeElement.setAttribute("inert", "");
                    activeElement.ariaExpanded = "false";
                });
            }
            // Activate current accordion section
            elementParent.classList.add("active");
            content.classList.add("active");
            content.ariaHidden = "false";
            content.removeAttribute("inert");
            element.ariaExpanded = "true";
        }
        else {
            if (this.allowAllClosed) {
                elementParent.classList.remove("active");
                content.classList.remove('active');
                content.ariaHidden = "true";
                content.setAttribute("inert", "");
                element.ariaExpanded = "false";
            }
        }
    };
    return Accordion;
}());
var globalAccordion = null;
/**
 * Handle accordion click event
 *
 * @param {Object} event
 */
window.accordionToggleEvent = function (event) {
    event.preventDefault();
    if (globalAccordion) {
        globalAccordion.toggleActive(event.currentTarget);
    }
};
// Initialize an instance of Accordion when the document content is fully loaded
document.addEventListener("DOMContentLoaded", function () {
    globalAccordion = new Accordion({ deactivateOthers: true });
    globalAccordion.init();
});
